import { ArticleType } from '@xcel-next/core/enums'

import type { ComposedTeaser } from './paragraph-schema/paragraphs'

const DEFAULT_TEASER_GROUP_SLIDER = 'bx-teaser-container--slider'
const RECIPE_TEASER_GROUP = 'bx-teaser-container--recipe'

export function shouldUseRecipeTeaserStyles (teaserGroupType: string, teasers: Array<Pick<ComposedTeaser, 'articleType'>>) {
  if (teaserGroupType === RECIPE_TEASER_GROUP) return true
  return teaserGroupType === DEFAULT_TEASER_GROUP_SLIDER && teasers.some(teaser => teaser.articleType === ArticleType.recipe)
}
